import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const PopperRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 0;
`;

export const PopperRowLabel = styled.span``;

export const StyledPopper = styled.div`
  position: absolute;
  top: -150px;
  width: 100%;
  margin-top: 5px;
  padding: 13px 20px;
  background: #fff;
  box-shadow: 0px 10px 30px #00000026;
  border: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  border-radius: 3px;
  z-index: 100;

  ${media.md`
    top: 72px;
    width: 350px;
    bottom: unset;
  `}
`;

export const PopperOptionLabelWrapper = styled.div`
  flex-grow: 1;
`;

export const PopperOptionLabelDescription = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  padding: ${({ theme }) => theme.spaces.space2} 0 0 0;
`;

export const PopperOptionCountButtons = styled.div`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;

export const PopperOptionCounter = styled.div`
  width: 30px;
  text-align: center;
`;
